import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ApplicationContext } from '@/v2/state/providers';
import Info from '@/v2/components/atoms/Icon/Info';
import Button from '@/v2/components/atoms/Button';
import { StateContext } from '@/v2/state/store';
import { AnalyticsContext } from '@/v2/components/application/Analytics';

import './Disclaimer.scss';

const propTypes = {
    data: PropTypes.object,
    dark: PropTypes.bool,
};

const defaultProps = {
    data: null,
    dark: false,
};

const getContent = (text, variant, f) => {
    const props = {
        icon: <Info />,
        className: 'Disclaimer__icon',
    };

    if (text !== '') {
        props.icon = null;
        props.className = '';
    }

    return (
        <Button onClick={f} variant={variant} type="button" {...props}>
            {text}
        </Button>
    );
};

const Disclaimer = ({ data, dark, gold, rightAligned }) => {
    const [{ header }] = useContext(ApplicationContext);

    const store = useContext(StateContext);
    const { trackEvent } = useContext(AnalyticsContext);
    const { dispatch } = store;

    const openDisclaimerOverlay = () => {
        dispatch({
            type: 'SHOW_DISCLAIMER_OVERLAY',
            disclaimerdata: data,
        });
        trackEvent('genericClick', {
            locationInPage: 'disclaimer',
        });
    };

    const classes = classNames({
        Disclaimer: true,
        'Disclaimer--active': true,
        Disclaimer__right: rightAligned,
    });

    let variant = dark ? 'icon-dark' : 'icon-light';
    variant = gold ? 'icon-gold' : variant;

    // eslint-disable-next-line  no-prototype-builtins
    const text = header.text.cta.hasOwnProperty('disclaimer') && header.text.cta.disclaimer != null ? header.text.cta.disclaimer : '';

    return <div className={classes}>{getContent(text, variant, openDisclaimerOverlay)}</div>;
};

Disclaimer.propTypes = propTypes;
Disclaimer.defaultProps = defaultProps;

export default Disclaimer;
